module.exports = __webpack_public_path__ + "static/media/SF-2.6d44367f.mp3";